import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class SaleAdjustmentShouldNotBeEInvoiceWithAdjustedWstoOss extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.sale.validation.ksef-document.wsto-oss-on-adjusted-document');
    }
}
